<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cn } from '@/components/shadcnui/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes["class"]
}>()
</script>

<template>
  <th :class="cn('h-10 px-2 text-left align-middle font-medium bg-gray-100 dark:bg-gray-900 [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5', props.class)">
    <slot />
  </th>
</template>
